import { faIceSkate } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

/**
 *
 * @param {string | number} shoeCamNumber
 * @returns {JSX.Element}
 */
const ShoeCamIcon = ({ shoeCamNumber }) => {
    return (
        <div className="pip-shoecam">
            <FontAwesomeIcon
                icon={faIceSkate}
                className="pip-shoecam-icon"
            />
            <span
                className="absolute pip-badge"
                color="white">
                {shoeCamNumber}
            </span>
        </div>
    );
};

export default ShoeCamIcon;
